import { AxiosResponse } from 'axios'
import { api } from './api'

export type Coupon = {
  id: string
  code: string
  productType: string
  merchantId?: string
  amount: number
}

export default class CouponsService {
  static async create(coupon: Coupon) {
    const response: AxiosResponse = await api.post('/v1/coupon', coupon)
    return response.data
  }
}
